import React, { useState, useEffect, useCallback } from 'react';
import styles from './DownloadHistory.module.css';
import { CustomList, CustomLoader, CustomTitle } from '../../../components';
import { useTranslation } from 'react-i18next';
import { getHistoryByUser } from '../../../services/historyService';
import { useSelector } from "react-redux";
import { RootState } from '../../../store/store';
import formatDate from '../../../utils/date';
import { useNavigate } from 'react-router-dom';

const DownloadHistory = () => {
    
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userId : number = useSelector((state: RootState) => state.auth.userId);

    const [isLoading, setIsLoading] = useState(true);
    const [downloadHistory, setDownloadHistory] = useState([]);

    const handleGetDownloadHistory = useCallback(async () => {
        setIsLoading(true);

        const historyResponse = await getHistoryByUser(userId);

        const formatedHistoryList = historyResponse.map((item: any) => {
            const el: ListElementType = {
                id : item.project?.documentId,
                title : item.project?.title || t('account.download_history.deleted_project'),
                description : formatDate(item.publishedAt),
                isDisabled : item.project == null
            }

            return el;
        });

        setDownloadHistory(formatedHistoryList);
        setIsLoading(false);
    }, [userId, t]);

    useEffect(() => {
        handleGetDownloadHistory();
    }, [handleGetDownloadHistory]);


    return (
        <div className={ styles.container }>
            { !isLoading &&
                <>
                    <CustomTitle className={styles.title}>{t('account.download_history.title')}</CustomTitle>

                    <div>
                        <CustomList
                            list={downloadHistory}
                            onClick={(e: ListElementType) => { navigate(`/store/${e.id}`); }}
                        />
                    </div>
                </>
            }

            <CustomLoader loaderType="skeleton" isLoading={isLoading}/>
        </div>
    );
}

export default DownloadHistory;